import { useCallback } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useDownloader } from '@trinity/chat-components/hooks/useDownloader';
import type { apiSchemas } from '@trinity/management-app-client';

type FormSchema = apiSchemas.FormSchema;

export type IconnectArtifactDownloadParams = {
  formData: Record<string, unknown>;
  formConfig: FormSchema;
  employeeName?: string;
  surveyName?: string;
};

export function useIconnectArtifactDownloader() {
  const apiClient = useChatApiClient();
  const downloader = useDownloader();

  return useCallback(
    async (params: IconnectArtifactDownloadParams) => {
      const formFields = params.formConfig.fields.map((f) => ({
        name: f.name,
        label: f.label,
        type: f.type,
      }));

      const result = await apiClient.chatInstances.downloadIconnectArtifact({
        formData: params.formData,
        formFields,
        employeeName: params.employeeName,
        surveyName: params.surveyName,
      });

      downloader({ blob: result.blob, filename: result.filename });
    },
    [apiClient, downloader]
  );
}
